import type {
    BulkOnboardingPricingPagePropertyOnboardingContextFieldsV1,
    BulkOnboardingPricingPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BulkOnboardingPricingPagePropertyOnboardingContextManifestV1,
    WebBulkOnboardingPricingPageVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/bulk-onboarding-pricing-page";
import {
    AddNewPayoutMethodElementPropertyOnboardingManifestV1,
    AgodaECardElementPropertyOnboardingManifestV1,
    BankTransferElementPropertyOnboardingManifestV1,
    ChannelManagerDropdownElementPropertyOnboardingManifestV1,
    EarningMethodElementPropertyOnboardingManifestV1,
    First3BookingPromotionElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    MinimumNightlyRateElementPropertyOnboardingManifestV2,
    MonthlyPromotionDiscountElementPropertyOnboardingManifestV1,
    MonthlyPromotionToggleElementPropertyOnboardingManifestV1,
    NightlyRateElementPropertyOnboardingManifestV2,
    PayoutDropdownElementPropertyOnboardingManifestV1,
    PaypalElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    SetChannelManagerElementPropertyOnboardingManifestV1,
    SetRateManuallyElementPropertyOnboardingManifestV1,
    UpcEPassElementPropertyOnboardingManifestV1,
    UpcElementPropertyOnboardingManifestV1,
    UseAnExistingPayoutMethodElementPropertyOnboardingManifestV1,
    WeeklyPromotionDiscountElementPropertyOnboardingManifestV1,
    WeeklyPromotionToggleElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const batchPricingBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<
        BulkOnboardingPricingPagePropertyOnboardingContextIdsV1,
        BulkOnboardingPricingPagePropertyOnboardingContextFieldsV1
    >(BulkOnboardingPricingPagePropertyOnboardingContextManifestV1.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebBulkOnboardingPricingPageVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], SetRateManuallyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], NightlyRateElementPropertyOnboardingManifestV2.ids, {
        property_id: BaseContextFieldsMapping.property_id,
        onboarding_id: BaseContextFieldsMapping.onboarding_id,
    });
    webAnalytics.observeElement([click, reveal], First3BookingPromotionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], WeeklyPromotionToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], WeeklyPromotionDiscountElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], MonthlyPromotionToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], MonthlyPromotionDiscountElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], EarningMethodElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "payment-method-name"),
    });
    webAnalytics.observeElement([click], SetChannelManagerElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], ChannelManagerDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "channel-manager-name"),
    });
    webAnalytics.observeElement([click, reveal], MinimumNightlyRateElementPropertyOnboardingManifestV2.ids, {
        property_id: BaseContextFieldsMapping.property_id,
        onboarding_id: BaseContextFieldsMapping.onboarding_id,
    });

    webAnalytics.observeElement([click, reveal], UseAnExistingPayoutMethodElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PayoutDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "payout-name"),
    });
    webAnalytics.observeElement([click, reveal], AddNewPayoutMethodElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], UpcElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], UpcEPassElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], AgodaECardElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], BankTransferElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PaypalElementPropertyOnboardingManifestV1.ids, {});
});
